import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LocalStorageService } from 'src/app/@shared/services/local-storage/local-storage.service';
import { FavoriteRoute } from 'src/app/modules/route-planner/interfaces/favorites/favorite-route.interface';
import { RoutePlanning } from 'src/app/modules/route-planner/interfaces/route-planning/@route-planning.interface';
import { SourceDestinationForm } from 'src/app/modules/route-planner/interfaces/route-planning/forms/source-destination-form';
import { FavoritesService } from 'src/app/modules/route-planner/services/favorites/favorites.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ManageFavoritesComponent } from '../../../../manage-favorites/manage-favorites.component';
import { ScheduleService } from 'src/app/modules/route-planner/services/schedule/schedule.service';
import { Section } from 'src/app/modules/route-planner/interfaces/route-planning/section.interface';
import { concatMap, forkJoin, Observable, tap } from 'rxjs';
import { eSectionType } from 'src/app/modules/route-planner/enums/route-planning/section-type.enum';
import { SpecialMessage } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/special-messages/special-message.interface';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { ModalService } from 'src/app/@shared/services/modal/modal.service';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import {
  DIDNT_ADD_FAVORITE_ROUTES,
  EDIT,
  FAVORITE_ROUTES,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Direction } from '@angular/cdk/bidi';

@Component({
    selector: 'app-favorite-routes',
    templateUrl: './favorite-routes.component.html',
    styleUrls: ['./favorite-routes.component.scss'],
    standalone: false
})
export class FavoriteRoutesComponent implements OnInit {
  @Output() onFavoriteRouteClick = new EventEmitter<{
    formValues: SourceDestinationForm;
    route: RoutePlanning;
  }>();

  favoriteRoutes: FavoriteRoute[] = [];

  favoriteRoutesText: string;
  editText: string;

  direction: Direction;
  didntAddFavoriteRoutesTextPart1: string;
  didntAddFavoriteRoutesTextPart2: string;

  constructor(
    private readonly routePlanningService: RoutePlanningService,
    private readonly scheduleService: ScheduleService,
    private readonly favoritesService: FavoritesService,
    private readonly modalService: ModalService,
    private readonly languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.favoriteRoutes = this.favoritesService.favorites?.routes?.slice(
      0,
      5
    ) as FavoriteRoute[];

    this.favoritesService.onFavoritesChange$.subscribe((favorites) => {
      this.favoriteRoutes = favorites?.routes?.slice(0, 5);
    });

    this.loadSpecialMessages();
    this.initializeMultiLanguageTexts();
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction;
      this.favoriteRoutesText = FAVORITE_ROUTES[language.language];
      this.editText = EDIT[language.language];
      const text = DIDNT_ADD_FAVORITE_ROUTES[language.language];
      const words = text.split(' ');
      this.didntAddFavoriteRoutesTextPart1 = words.slice(0, 3).join(' ');
      this.didntAddFavoriteRoutesTextPart2 = words.slice(3).join(' ');
    });
  }

  loadSpecialMessages() {
    this.favoriteRoutes?.map((favoriteRoute) => {
      favoriteRoute.route.specialMessages.routeMessages = [];
      favoriteRoute.route.specialMessages.stopMessages = [];
      const stopCodes: string[] = [];
      const routeDescs: string[] = [];

      favoriteRoute.route.sections?.map((section: Section) => {
        if (section.type === eSectionType.TRANSIT) {
          routeDescs.push(section.transport.description);
          stopCodes.push(section.departure.place.code);
          stopCodes.push(section.arrival.place.code);
          section.intermediateStops.forEach((stop) =>
            stopCodes.push(stop.departure.place.code)
          );
        }
      });
      this.scheduleService
        .GetSpecialMessageByManyRouteDesc(routeDescs)
        .pipe(
          tap((response) => {
            favoriteRoute.route.specialMessages.routeMessages = [
              ...favoriteRoute.route.specialMessages.routeMessages,
              ...response.data,
            ];
          })
        )
        .subscribe();

      this.scheduleService
        .getSpecialMessageByStopCodes(stopCodes)
        .pipe(
          tap((response) => {
            response.data.forEach(
              (stopData) =>
                (favoriteRoute.route.specialMessages.stopMessages = [
                  ...favoriteRoute.route.specialMessages.stopMessages,
                  ...stopData.specialMessages,
                ])
            );
          })
        )
        .subscribe();
    });
  }

  openSpecialMessages(route: RoutePlanning) {
    const messages = [
      ...route.specialMessages.routeMessages,
      ...route.specialMessages.stopMessages,
    ];
    this.modalService.openSpecialMessagesModal(messages);
  }

  openEditFavoritesMenu() {
    this.routePlanningService._componentOverlaySub.next({
      componentType: ManageFavoritesComponent,
      data: {
        closeCallbackFn: (reOpen: boolean) => {
          if(reOpen) {
            this.openEditFavoritesMenu();
          }
          else { 
            this.favoriteRoutes = this.favoritesService.favorites.routes.slice(
              0,
              5
            );
          }
          
        },
      },
    });
  }
}
